import { getEnv } from 'core_main/globals/env';
import {
  ArticleSurvey,
  KnowledgeBaseConfigApiResponse,
} from 'core_main/api/knowledge_bases/types';
import { GetKnowledgeBaseConfigCallbackResponse } from './types';

export const normalizeArticleSurvey = (
  config: KnowledgeBaseConfigApiResponse,
): Maybe<ArticleSurvey> => {
  return config.data.attributes.articleSurvey;
};
export const getHostDomain = () => {
  const { baseUrlDomain } = getEnv();
  if (baseUrlDomain?.includes('helpapp')) return 'helpapp';
  if (baseUrlDomain?.includes('helpsimply')) return 'helpsimply';
  return 'kustomer';
};

export const makeInternalKnowledgeBaseDomainName = () => {
  const { orgName } = getEnv();
  return `https://${orgName}.${getHostDomain()}.help`;
};

export const constructKnowledgeBaseConfigCallbackResponse = (
  config: KnowledgeBaseConfigApiResponse,
): GetKnowledgeBaseConfigCallbackResponse => {
  const { domain, baseUrl } = config.data.attributes;
  const internalDomain = baseUrl || makeInternalKnowledgeBaseDomainName();
  const domainName = domain?.domainName
    ? `https://${domain?.domainName}`
    : internalDomain;
  const knowledgeBaseDomain =
    domainName?.[domainName.length - 1] === '/' ? domainName : `${domainName}/`;

  return {
    id: config.data.id,
    articleSurvey: config?.data?.attributes?.articleSurvey,
    knowledgeBaseDomain,
  };
};
